// src/infra/api/ParametrosAnaliseApi.js
import axiosInstance from '../axios';
import { PARAMETROS_DEFAULT } from '../../pages/Parametros/mock/parametrosDefault';

/**
 * Mescla a resposta do backend com os defaults locais.
 * Garante que campos novos (adicionados no front) existam mesmo
 * que o backend ainda não os conheça.
 */
function mergeWithDefaults(data) {
    const merged = structuredClone(PARAMETROS_DEFAULT);
    if (!data || typeof data !== 'object') return merged;
    for (const group of Object.keys(merged)) {
        if (data[group] === undefined || data[group] === null) continue;
        if (Array.isArray(merged[group])) {
            if (Array.isArray(data[group])) merged[group] = data[group];
        } else if (typeof data[group] === 'object') {
            merged[group] = { ...merged[group], ...data[group] };
        }
    }
    return merged;
}

export async function getParametros() {
    const { data } = await axiosInstance.get('/parametros-analise');
    return mergeWithDefaults(data);
}

export async function saveParametros(payload) {
    try {
        const { data } = await axiosInstance.put('/parametros-analise', payload);
        return mergeWithDefaults(data);
    } catch (error) {
        throw new Error(error?.response?.data?.message || 'Falha ao salvar parâmetros');
    }
}

export async function resetParametros() {
    try {
        await axiosInstance.post('/parametros-analise/reset');
        return structuredClone(PARAMETROS_DEFAULT);
    } catch (error) {
        throw new Error(error?.response?.data?.message || 'Falha ao restaurar parâmetros');
    }
}

export function exportConfig(params) {
    try {
        const blob = new Blob([JSON.stringify(params, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `parametros-analise-${Date.now()}.json`;
        a.click();
        URL.revokeObjectURL(url);
    } catch (e) {
        throw new Error(e?.message || 'Falha ao exportar configuração');
    }
}

export async function importConfig(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try { resolve(JSON.parse(e.target.result)); }
            catch { reject(new Error('Arquivo JSON inválido')); }
        };
        reader.onerror = () => reject(new Error('Falha ao ler arquivo'));
        reader.readAsText(file);
    });
}
